import { isPathActive } from '$lib/routing/path-matching.js'

export type ShellDestinationId =
    | 'home'
    | 'messages'
    | 'learning'
    | 'gallery'
    | 'library'
    | 'daily-report'
    | 'my-account'

export const ShellDestinationIds: ShellDestinationId[] = [
    'home',
    'messages',
    'learning',
    'gallery',
    'library',
    'daily-report',
    'my-account'
]

/** Structural ownership only; selected-child authorization is a separate concern. */
export function getShellDestinationId(pathname: string): ShellDestinationId | undefined {
    if (pathname === '/attendance/absence/new' || pathname === '/drop-off-notes/new') {
        return 'home'
    }

    return ShellDestinationIds.find((destination) => isPathActive(pathname, `/${destination}`))
}
